<template>
  <q-btn
    class="tw-bg-skyWaste tw-text-white"
    :label="
      nmRoute === 'serviceRequest.start'
        ? $gettext('PENDING_SERVICE') +' [ '+sizeOpen+' ]'
        : clientName+' [ '+sizeOpen+' ]'
    "
    :icon="nmRoute === 'serviceRequest.start' ? 'sms' : 'mdi-swap-vertical'"
    size="12px"
  >
    <q-menu>
      <q-card>
        <div class="tw-px-4 tw-pt-3 tw-flex tw-items-stretch">
          <div class="tw-flex-grow">
            <q-input
              v-model="searchFilter"
              :label="$gettext('SEARCH')"
              outlined
            >
              <template v-slot:append>
                <q-icon name="search"></q-icon>
              </template>
            </q-input>
          </div>
          <div class="tw-flex-shrink-0 tw-flex tw-items-center">
            <q-btn
              v-if="$router.currentRoute.name != 'serviceRequest.start'"
              class="tw-bg-skyWaste tw-text-white tw-h-full"
              @click="$emit('onNew')"
            >
              <translate>NEW</translate>
            </q-btn>
          </div>
        </div>

        <q-card-section
          v-for="(serviceRequest, index) in filteredServiceRequests(state.serviceRequests )"
          :key="index"
        >
          <q-card
            :class="classCardService(serviceRequest, protocol)"
          >
            <q-card-section>
              <q-icon name="date_range" />
              {{ formatDate(serviceRequest.startDate.split(" ")[0]) }}
              <q-icon name="timer" />{{
                formatHour(serviceRequest.startDate.split(" ")[1])
              }}
            </q-card-section>
            <q-card-section
              >{{ $gettext("PROTOCOL") }}:<strong>{{
                serviceRequest.protocol
              }}</strong></q-card-section
            >
            <q-card-actions class="justify-center">
              <q-btn-dropdown
                no-caps
                :label="
                  serviceRequest.clientName.length > 30
                    ? serviceRequest.clientName.substring(0, 30) + '...'
                    : serviceRequest.clientName
                "
                class="bg-white text-black"
                style="width: 94%; font-size: 13px"
              >
                <div class="column no-wrap">
                  <div class="row">
                    <span
                      ><strong>{{ $gettext("EMAIL") }}:</strong>
                      {{ serviceRequest.clientEmail }}</span
                    >
                  </div>
                  <div class="row">
                    <span
                      ><strong>{{ $gettext("PHONE") }}:</strong>
                      {{
                        serviceRequest.clientPhone === null
                          ? ""
                          : serviceRequest.clientPhone
                      }}</span
                    >
                  </div>
                </div>
              </q-btn-dropdown>
            </q-card-actions>

            <div
              class="div-button-next"
              @click="
                () =>
                  $emit(
                    'onChangeService',
                    serviceRequest.protocol,
                    serviceRequest.protocol == protocol
                  )
              "
            >
              {{
                serviceRequest.protocol == protocol &&
                nmRoute != "serviceRequest.list"
                  ? $gettext("CONSUMER_UNITS")
                  : $gettext("CONTINUE_SERVICE")
              }}
              <q-icon name="arrow_right" size="20px" />
            </div>
          </q-card>
        </q-card-section>
      </q-card>
    </q-menu>
  </q-btn>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import ServiceRequestModel from '../ServiceRequestModel'
import moment from 'moment'

@Component({
  name: 'ServiceRequestExpansionButton',
  components: {},
  props: {
    protocol: String,
    nmRoute: String
  }
})
class ServiceRequestExpansionButton extends Vue {
  state = ServiceRequestModel.getInstance();
  searchFilter = '';

  formatDate (date) {
    const finalDateSplit = date.split('-')
    const year = finalDateSplit[0]
    const month = finalDateSplit[1]
    const day = finalDateSplit[2]
    const finalDate = day + '/' + month + '/' + year
    return finalDate
  }

  formatHour (hour) {
    const finalHourSplit = hour.split(':')
    const finalHour = finalHourSplit[0] + ':' + finalHourSplit[1]
    return finalHour
  }

  get clientName () {
    return this.state.serviceRequests[parseInt(this.protocol)]?.clientName || this.$gettext('PENDING_SERVICE')
  }

  get sizeOpen () {
    return Object.keys(this.state.serviceRequests || {}).length
  }

  filteredServiceRequests (requests) {
    for (const prop in requests) {
      if (Object.prototype.hasOwnProperty.call(requests, prop)) {
        const re = new RegExp(this.searchFilter, 'i')
        if (!requests[parseInt(prop)].clientName?.match(re)) {
          delete requests[parseInt(prop)]
        }
      }
    }
    return requests
  }

  isNowDay (obj) {
    const dataAtual = moment()
    const dataStartDate = moment(obj.startDate, 'YYYY-MM-DD HH:mm:ss.S')

    return dataStartDate.isSame(dataAtual, 'day')
  }

  classCardService (serviceRequest, protocol) {
    var classe = 'tw-bg-skyWaste small-card text-white '
    if (serviceRequest.protocol == protocol) {
      classe += ' blue-card  '
    } else if (!this.isNowDay(serviceRequest)) {
      classe += ' red-card  '
    }
    return classe
  }
}

export default ServiceRequestExpansionButton
</script>

<style lang="scss" scoped>
@import "tailwindcss/utilities";
.blue-card {
  background-color: #3c89c5 !important;
}

.red-card {
  background-color: hsl(12, 71%, 66%) !important;
}

.center-child {
  display: flex;
  justify-content: center;
}

.div-button-next {
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
}
.expansion-item-header {
  font-weight: 550;

  .q-item__section--side {
    padding-right: 0px !important;
    padding-left: 0px !important;
  }

  .q-icon {
    margin-left: 10px;
    margin-right: 7px;
    color: white !important;
  }

  .q-item__section--main {
    align-items: center;
  }
}

.header-start {
  .q-item__section--avatar {
    min-width: 35px !important;
  }

  .q-expansion-item__toggle-icon {
    max-width: 0px !important;
    min-width: 0px !important;
  }
}

.header-default {
  .q-item__section--avatar {
    min-width: 0px !important;
  }

  .q-expansion-item__toggle-icon {
    max-width: 0px !important;
    min-width: 0px !important;
  }
}

.small-card {
  .q-card__section--vert {
    padding: 5px !important;
    padding-left: 10px !important;
  }

  .q-card__actions {
    padding: 5px !important;
    padding-left: 0px !important;
  }
}

.expansion-item-card {
  .q-card {
    margin: 0px !important;
    padding: 0px !important;
    padding-bottom: 10px !important;
  }
}
</style>
